export default "/images/0ddbaeaabfec633b70c92be96885235a.png";